import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import GlobalTable from "../../../components/global-table";
import { EmployeeContextProvider, useEmployeeContext } from "../../../context/employee-context";
import { useOrganizationContext } from "../../../context/organization-context";
import { Button, Col, Dialog,  Row, Typography } from "../../../ppui";
import { logger } from "../../../utils/logger";
import { ContentLayout, ContentTable } from "../../style";
import EmployeeImport from "../employee-import";
import { headers } from "../employee.data";
import EmployeeExportPDF from "./employee-export-pdf";
import EmployeeListService from "./employee-list-service";
import { exportEmployeeDataToCSV } from "./export-to-csv";
import EmployeeDetailsBlukPDF from "./emp-details-bluk-pdf";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import useOrgDetailsFullDataHook from "../../../lib/useOrgFullDetails";

function EmployeeList() {
  const {
    emplistdata,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    getEmployeeListFn,
    totalEmployee,
    employeeExportData,
    organizationInfoEmpExport,
    isLoading,
    employeeListExportLoading
  } = EmployeeListService();
  const{organizationFullInfo}=useOrgDetailsFullDataHook()
  const navigate = useNavigate();

  const employeeCreate = () => {
    const path = `/employee`;
    navigate(path);
  };

  // const FetchDataFromRow = (row) => {
  //   const temp = `/employee/profile/${row?.employee_id}`;
  //   navigate(temp);
  // };
  const {
    branchList,
    stateList
  } = useEmployeeContext() || {}; 
  const {
    orgConfigationDetails
  } = useOrganizationContext() || {}; 
  const [openImportModal, setOpenImportModal] = useState(false);
  const handleOpenImportModal = () => {
    setOpenImportModal(true);
  };
  const handleCloseImportModal = () => {
    setOpenImportModal(false);
  };
  const currentRoute = location.pathname.split("/").pop();
logger.log(orgConfigationDetails,"orgConfigationDetails0000")
  const orgInitials = organizationInfoEmpExport?.org_name?.split(' ').map(word => word[0]?.toUpperCase()).join('');
  const handleExportCSV = () => {
    exportEmployeeDataToCSV(employeeExportData, branchList, orgInitials);
  };

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isBulkDownloading, setIsBulkDownloading] = useState(false);

  const handleBulkDownload = async () => {
    setIsBulkDownloading(true);
    try{
      logger.log(employeeExportData, "testy")
      const zip = new JSZip();
      for (const employee of employeeExportData) {
        const pdfBlob = await generatePdfBlob(employee);
        zip.file(`${employee?.first_name}_${employee?.last_name}_${employee?.employee_code}_Info.pdf`, pdfBlob);
      }
    
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "Employee-Info.zip");
    }catch (error) {
      console.error("Error generating bulk download:", error);
    }finally{
      setIsBulkDownloading(false);
    }
  }

  const generatePdfBlob = async (employee) => {
    const pdfDocument = 
    <EmployeeDetailsBlukPDF
      data={employee}
      orgDetails={organizationInfoEmpExport}
      branchList={branchList}
      stateList={stateList}
      organizationFullInfo={organizationFullInfo}
    />;
    const pdfBlob = await pdf(pdfDocument).toBlob();
    return pdfBlob;
  };
  return (
    <>
    <EmployeeContextProvider>
      <ContentLayout>
        <ContentTable>
          <GlobalTable
            headers={headers(currentPage, rowsPerPage,branchList)}
            rows={emplistdata}
            ActiveSort={false}
            searchBox={true}
            columnManagement={true}
            avatar={true}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages} // Pass total pages
            handleNextPage={handleNextPage} // Pass next page handler
            handlePreviousPage={handlePreviousPage} // Pass previous page handler
            handleRowsPerPageChange={handleRowsPerPageChange} // Pass rows-per-page handler
            // FetchDataFromRow={FetchDataFromRow}
            stickyHeader="true"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            maxHeight={true}
            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                  {currentRoute === "employee-list"
                    ? `Total Number of Employee : ${totalEmployee}`
                    : currentRoute === "employee-onboarding"
                      ? `Total Number of Onboarding Employee : ${totalEmployee}`
                      : currentRoute === "employee-exit"
                        ? `Total Number of Exit Employee : ${totalEmployee}`
                        : currentRoute === "employee-inactive"
                          ? `Total Number of Inactive Employee : ${totalEmployee}`
                          : `Total Number of Employee : ${totalEmployee}`}
                </Typography>
              </>
            }
            actionRight={
              <>
                {currentRoute === "employee-inactive" ? (
                  <></>
                ) : (
                  <>
                    {/* <Button variant="outlined" onClick={handleOpenImportModal}>
                      Export
                    </Button> */}

                    <Button variant="outlined" onClick={handleOpenImportModal}>
                      Import
                    </Button>
                  </>
                )}
                <Button
                  variant="outlined"
                  disabled={isLoading}
                  onClick={handleClickOpen}
                >
                  Export
                </Button>
                {currentRoute === "employee-inactive" ? (
                  <></>
                ) : (
                  <>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={employeeCreate}
                    >
                      Add Employee
                    </Button>
                  </>
                )}
              </>
            }
          />
        </ContentTable>
        <EmployeeImport
          openImportModal={openImportModal}
          handleOpenImportModal={handleOpenImportModal}
          handleCloseImportModal={handleCloseImportModal}
          getEmployeeListFn={getEmployeeListFn}
        />
      </ContentLayout>
      </EmployeeContextProvider>
      <Dialog
          title={`Employee Info Export`}
          closeButton={true}
          fullWidth
          maxWidth="xs"
          open={open}
          onClose={handleClose}
          separator
          action={false}
          //   footer={
          //   <>
          //   <Button variant="text" onClick={() => alert("Custom Action")}>Custom Footer Action</Button>,
          // </>
          // }
        >
          <Row>
            <Col xs="6">
            <Button variant="outlined" fullWidth disabled={isLoading} onClick={handleExportCSV}>
              CSV File
            </Button>
            </Col>
            <Col xs="6">
              <PDFDownloadLink
                document={
                  <EmployeeExportPDF
                    employeeExportData={employeeExportData}
                    branchList={branchList}
                    organizationInfoEmpExport={organizationInfoEmpExport}
                  />}
                fileName={`${orgInitials}-Employee-List.pdf`}
              >
                {/* {({ employeeListExportLoading }) => ( */}
                  <Button variant="outlined" disabled={employeeListExportLoading} fullWidth loading={employeeListExportLoading}>
                    {employeeListExportLoading ? "loading.." : "PDF File"}
                  </Button>
                {/* )} */}
              </PDFDownloadLink>
            </Col>
          <Col xs="6" mt="10">
            <Button
              variant="outlined"
              loading={isBulkDownloading}  
              fullWidth
              onClick={() => handleBulkDownload()}
            >Bulk Employee Info</Button>
          </Col>
          </Row>
        </Dialog>
    </>
  );
}

export default EmployeeList;
